import {
  Calendar,
  CalendarEvent,
  EventDetailsModal,
  transformMeetingsToCalendarEvents,
} from '@consigli/facade';
import { useMeetings, useProjectId } from '@consigli/hooks';
import { useMemo, useState, useCallback } from 'react';

export const MeetingSecretaryCalendar = () => {
  const projectId = useProjectId();
  const { meetings } = useMeetings({ projectId });
  const [selectedEvent, setSelectedEvent] = useState<CalendarEvent | null>(null);

  const calendarEvents = useMemo(() => {
    return transformMeetingsToCalendarEvents(meetings);
  }, [meetings]);

  const handleEventClick = useCallback((event: CalendarEvent) => {
    setSelectedEvent(event);
  }, []);

  const handleCloseModal = useCallback(() => {
    setSelectedEvent(null);
  }, []);

  return (
    <div className="flex-1 overflow-hidden bg-background px-12 py-6">
      <Calendar events={calendarEvents} onEventClick={handleEventClick} />
      {selectedEvent && <EventDetailsModal event={selectedEvent} onClose={handleCloseModal} />}
    </div>
  );
};
